/* src/app/components/lead-details/add-sick-time/add-sick-time.component.css */
:host ::ng-deep .ppl-form-control {
  width: 100%;
}
:host ::ng-deep .ppl-form-control nz-select,
:host ::ng-deep .ppl-form-control p-datepicker,
:host ::ng-deep .ppl-form-control .p-datepicker,
:host ::ng-deep .ppl-form-control .p-inputtext {
  width: 100%;
}
:host ::ng-deep .ppl-form-control .ant-select {
  width: 100%;
}
.required-asterisk {
  color: red;
}
/*# sourceMappingURL=add-sick-time.component-SQCRHVOK.css.map */
